export default "__VITE_ASSET__Cji9iu6F__"